import { Checkbox } from 'antd'
import Checkboxes from 'components/Form/Checkbox'
import styled from 'styled-components'

export const StyledGroup = styled(Checkbox.Group)`
  gap: ${props => (props.gap ? props.gap : '')};
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: ${props => (props.column ? props.column : 'column')};
  margin-top: ${props => (props.margin ? props.margin : '1rem')};
  text-transform: capitalize;
`
export const StyledCheckbox = styled(Checkboxes)`
  margin-left: 0 !important;
  padding: ${props => props.padding};
`
